// TODO* Common搜索组件的埋点均为空，需要删掉
'use client';
import { getHotWordsApi, getSuggestWordsApi } from '@/apis/header/header.api';
import { getDefaultWords, getSearchResults } from '@/apis/shopCategory';
import { createTrackParams, EXPCONFIG_DELAY, EXPCONFIG_FAST } from '@/app/s/util';
import SearchBtn from '@/assets/icons/search-btn.svg';
import UKToast from '@/components/UKToast/index';
import { useTranslation } from '@/i18n/client';
import { EXPOSURE_RECORD as EXPOSURE_RECORD23661 } from '@/tracks/23661';
import {
  EXPOSURE_RECORD as EXPOSURE_RECORD24270,
  sendClickTrack as sendClickTrack24270,
} from '@/tracks/24270';
import {
  EXPOSURE_RECORD as EXPOSURE_RECORD25149,
  IExpoTrackParamsRecord as IExpoTrackParamsRecord25149,
  sendClickTrack as sendClickTrack25149,
} from '@/tracks/25149';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25156';
import cookieUtils from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
import { useRequest } from 'ahooks';
import cn from 'clsx';
import { useParams, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useRef, useState } from 'react';
import styles from './index.module.scss';
import _ from 'lodash';
import { getCookieConsent } from '@/intl-jdi-common-ssr/constants/cookie';
import CDNImage from '@/components/cdnImage/cdnImage';
import SearchRight from '@/assets/icons/search-right.svg';
import {
  SEARCH_EVENT_NAMES,
  searchBusinessLogger,
} from '@/utils/logger/instance/searchBusinessLogger';
const isUseRecentWordsAllowed = () => {
  const { f = '0' } = getCookieConsent();
  return !!f;
};

interface props {
  defaultKeyword?: string;
  tracks?: {
    logid?: string;
    channelName?: string;
    abver?: string;
  };
  poolData?: any;
  pageCode?: string;
}

interface ShopInfo {
  shopName?: string;
}

interface IEventTrack {
  NormalizedKey: string;
  QPParsedLanguage: string;
}

interface DefaultWordsItem {
  keyword: string;
  icon: string;
  landingPage: number;
  jumpPc: string;
  jumpMobile: string;
  extMap?: {
    algoid?: string;
    requestId?: string;
  };
}

const JDISearch = ({ defaultKeyword, tracks, poolData, pageCode }: props) => {
  const { t } = useTranslation();
  const { logid = '-100', channelName = '-100', abver = '-100' } = tracks || {};
  const [isFocusedSearchInput, setIsFocusedSearchInput] = useState(false);
  const isHideSearchInput = useRef<any>(null);
  const shopKeywords = useSearchParams().get('shopKeywords');
  const [keyword, setKeyword] = useState(defaultKeyword || shopKeywords || '');
  const [hotWordsList, setHotWordsList] = useState([]); //热词列表
  const [recentlySearched, setRecentlySearched] = useState<string[]>([]); //最近搜索词
  const [suggestWords, setSuggestWords] = useState<any[]>([]); //联想词
  const [defaultWords, setDefaultWords] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [extMap, setExtMap] = useState<any>({});
  const [searchType, setSearchType] = useState<string>('');
  const [shopInfoVO, setShopInfoVO] = useState<ShopInfo>({});
  const [eventTrackMap, setEventTrackMap] = useState<IEventTrack>({
    NormalizedKey: '-100',
    QPParsedLanguage: '-100',
  });
  const router = useRouter();
  const shopId = useSearchParams().get('shopId');
  const storeId = useParams().storeId || ''; // storeId兼容搜索框
  const searchParams = useSearchParams();
  const productPool = poolData?.dataBatch?.globalSetting?.[0]?.['page-product-pool'] || {};
  const poolIdList = productPool?.activityId || searchParams.get('poolIdList') || '';
  const tabName = poolData?.dataBatch?.globalSetting?.[0]?.title || '';
  const channelPageName = tabName || searchParams.get('channelPageName') || '';

  const commonTracks = useMemo(
    () => ({
      pvid: logid || '-100',
      logid: logid || '-100',
      channelName,
      abver,
      ...eventTrackMap,
    }),
    [logid, channelName, abver, eventTrackMap],
  );
  useEffect(() => {
    const fetchDefaultWords = async () => {
      searchBusinessLogger({
        eventName: SEARCH_EVENT_NAMES.SEARCH_BACK_FETCH_START,
      });
      const defaultData = await getDefaultWords();
      const words =
        defaultData.data?.defaultWordsItems?.map((item: DefaultWordsItem) => item.keyword) || [];
      const extMapArray =
        defaultData.data?.defaultWordsItems?.map((item: DefaultWordsItem) => item.extMap) || [];
      if (defaultData.success && words.length > 0) {
        // 手动触发底纹曝光
        eventTrackingUtils.submitExp({
          event_id: EXPOSURE_RECORD23661.Home_Search_Hints,
          json_param: {
            keyWord: words,
            request_id: extMapArray[0]?.requestId || '',
            algo_rd_inf: extMapArray[0]?.algoid || '',
          },
        });
      }
      if (words?.length == 0) {
        searchBusinessLogger({
          eventName: SEARCH_EVENT_NAMES.SEARCH_BACK_NO_DATA,
          message: {
            words,
          },
        });
      }
      setDefaultWords(words);
      setExtMap(extMapArray[0]);
    };
    if (!new URL(location.href).pathname.startsWith('/minihome/')) {
      fetchDefaultWords();
    }
  }, []);

  useEffect(() => {
    if (defaultWords.length === 0) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % defaultWords.length);
    }, 1500);

    return () => clearInterval(timer);
  }, [defaultWords.length]);

  const handleInputChange = (e: any) => {
    const keyword = e.target.value;
    setKeyword(keyword || '');
    debouncedHandleSuggestWordsRequest(keyword);
  };

  const getShopIdWithDefault = () => {
    return (shopId || storeId).toString();
  };

  // getShop方法接受参数
  const getShop = async (currentShopId: string) => {
    if (!currentShopId) return;
    const searchResults = await getSearchResults({ shopId: currentShopId });
    const { shopInfoVO = {}, eventTrackMap = {} } = searchResults.data ?? {};
    setShopInfoVO(shopInfoVO);
    setEventTrackMap({
      NormalizedKey: eventTrackMap.NormalizedKey || '-100',
      QPParsedLanguage: eventTrackMap.QPParsedLanguage || '-100',
    });
  };

  const handleSearchClick = () => {
    sendClickTrack25149.Search_SearchBtn({
      ...commonTracks,
      keyWord: keyword,
      shopid: getShopIdWithDefault() || '-100',
    });
    const resultKeyword = keyword.trim();
    const defaultKeyword = defaultWords[currentIndex];
    if (resultKeyword) {
      updateRecentlySearched(resultKeyword);
      sendClickTrack24270.Search_SearchBtn({
        keyWord: resultKeyword,
        shopid: getShopIdWithDefault() || '-100',
        searchtype: 'active search',
        ...commonTracks,
      });
      const params = _.omitBy(
        {
          //店铺搜索用shopKeywords
          ...(getShopIdWithDefault()
            ? { shopKeywords: resultKeyword, shopId: getShopIdWithDefault() }
            : { k: resultKeyword }),
          channelPageName,
          poolIdList,
          st: 'active search',
        },
        (v) => v === undefined || v === '',
      );
      router.push(`/s?${new URLSearchParams(params).toString()}`);
    } else if (defaultKeyword && !new URL(location.href).pathname.startsWith('/minihome/')) {
      updateRecentlySearched(defaultKeyword);
      sendClickTrack24270.Search_SearchBtn({
        keyWord: defaultKeyword,
        shopid: getShopIdWithDefault() || '-100',
        searchtype: 'hints',
        ...commonTracks,
      });
      const params = _.omitBy(
        {
          k: defaultKeyword,
          st: 'hints',
          ...(extMap?.algoid && { al: extMap.algoid }),
          ...(extMap?.requestId && { r: extMap.requestId }),
        },
        (v) => v === undefined || v === '',
      );
      router.push(`/s?${new URLSearchParams(params).toString()}`);
    } else {
      UKToast.show({
        content: t('s.alert'),
        icon: 'warning',
      });
    }
  };

  // 新增方法：用于热词和历史点击
  const handleQuickSearch = (
    keyword: string,
    type: 'search history' | 'hot search',
    extMap?: any,
  ) => {
    const resultKeyword = keyword.trim();
    if (resultKeyword) {
      updateRecentlySearched(keyword);
      sendClickTrack24270.Search_SearchBtn({
        keyWord: keyword,
        shopid: getShopIdWithDefault() || '-100',
        searchtype: type,
        ...commonTracks,
      });
      const params = _.omitBy(
        {
          //店铺搜索用shopKeywords
          ...(getShopIdWithDefault()
            ? { shopKeywords: resultKeyword, shopId: getShopIdWithDefault() }
            : { k: resultKeyword }),
          channelPageName,
          poolIdList,
          st: type,
          ...(type === 'hot search' && {
            ...(extMap?.algoid && { al: extMap.algoid }),
            ...(extMap?.requestId && { r: extMap.requestId }),
          }),
        },
        (v) => v === undefined || v === '',
      );
      router.push(`/s?${new URLSearchParams(params).toString()}`);
    }
  };

  const handleSearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };
  const handleSearchInputClick = () => {
    sendClickTrack25149.Search_SearchBox({ channelName, shopid: getShopIdWithDefault() || '-100' });
  };

  //获取热词
  const getHotWords = async (shopId?: string) => {
    const params = shopId ? { num: 15, shopId } : { num: 15 };
    const res = await getHotWordsApi(params);
    const { code, data } = res;
    if (code === '200' && data?.hotWordsItems && data?.hotWordsItems?.length > 0) {
      setHotWordsList(data.hotWordsItems);
    }
  };

  //获取最近搜索词
  const getRecentlySearched = () => {
    if (!isUseRecentWordsAllowed()) {
      return;
    }
    setRecentlySearched(JSON.parse(cookieUtils.getLocalStorage('SEARCH_KEYWORDS_KEY') || '[]'));
  };

  //更新最近搜索词
  const updateRecentlySearched = (keyword: string) => {
    if (!isUseRecentWordsAllowed()) {
      return;
    }
    if (keyword) {
      const keys: string[] = recentlySearched.filter((item) => item !== keyword);
      keys.unshift(keyword);
      setRecentlySearched(keys.slice(0, 10));
      cookieUtils.setLocalStorage('SEARCH_KEYWORDS_KEY', JSON.stringify(keys.slice(0, 10)));
    }
  };

  //清空最近搜索词
  const clearRecentKeywords = () => {
    if (!isUseRecentWordsAllowed()) {
      return;
    }
    setRecentlySearched([]);
    cookieUtils.setLocalStorage('SEARCH_KEYWORDS_KEY', JSON.stringify([]));
    sendClickTrack25149.Search_Delete({
      channelName,
      shopid: getShopIdWithDefault() || '-100',
    });
  };

  const onMouseEnter = () => {
    clearTimeout(isHideSearchInput.current);
  };

  const onMouseLeave = () => {
    isHideSearchInput.current = setTimeout(() => {
      setIsFocusedSearchInput(false);
    }, 1000);
  };

  //获取联想词
  const handleSuggestWordsRequest = async (keywords: string) => {
    const params: any = { keywords };
    if (channelPageName) {
      params.channelPage = {
        channelPageName,
        poolIdList: [poolIdList],
      };
    }
    searchBusinessLogger({
      eventName: SEARCH_EVENT_NAMES.SEARCH_SUG_FETCH_START,
      message: {
        params,
      },
    });
    const res = await getSuggestWordsApi(params);
    const { code, data } = res;
    if (code === '200' && data && data.suggestItems) {
      setSuggestWords(
        data.suggestItems.map((item: any, index: number) => {
          const word = item.keyword;
          let realKeyword = '';
          let miniKeyword = '';
          let highlighted = '';

          const inIndex = word.toLowerCase().indexOf('in ');

          if (inIndex !== -1) {
            realKeyword = word.substring(0, inIndex - 1);
            miniKeyword = word.substring(inIndex - 1);
            for (const char of realKeyword) {
              if (keyword.includes(char)) {
                highlighted += `<mark>${char}</mark>`;
              } else {
                highlighted += char;
              }
            }
          } else {
            realKeyword = word;
            miniKeyword = '';
            highlighted = word;
          }

          return {
            keyword: realKeyword,
            word: word,
            highlightedKeyword: highlighted,
            miniKeyword: miniKeyword,
            type: item.type,
            suggestShopVO: item.suggestShopVO,
          };
        }),
      );
    } else {
      setSuggestWords([]);
    }
    if (data?.suggestItems?.length === 0) {
      searchBusinessLogger({
        eventName: SEARCH_EVENT_NAMES.SEARCH_SUG_N0_DATA,
        message: {
          keyword,
          data,
        },
      });
    }
  };

  // input输入防抖
  const { run: debouncedHandleSuggestWordsRequest } = useRequest(handleSuggestWordsRequest, {
    debounceWait: 500,
    debounceLeading: true,
    manual: true,
  });

  const handleSelectKeywords = (
    keyword: string,
    word: string,
    idx: number,
    input_kw: string,
    type: number,
    shopId?: string,
  ) => {
    if (!keyword) {
      return;
    }
    let shouldAddTopKeyFilters = false;
    if (channelPageName && word.includes(channelPageName)) {
      shouldAddTopKeyFilters = true;
    }
    setKeyword(keyword);
    updateRecentlySearched(keyword);
    if (type === 1) {
      sendClickTrack.Search_Sug_Shop_Entry({
        index: idx,
        keyword: keyword,
        ...commonTracks,
        shopid: shopId || '-100',
      });
      const params = _.omitBy(
        {
          channelPageName,
          poolIdList,
          ...(shouldAddTopKeyFilters && { topKeyFilters: 'channel_page_filter' }),
          st: 'suggestion',
        },
        (v) => v === undefined || v === '',
      );
      router.push(`/store/${shopId}?${new URLSearchParams(params).toString()}`);
    } else {
      sendClickTrack.Search_Sug_AssociativeWord({
        pos: idx,
        keyWord: keyword,
        Input_Keyword: input_kw,
        ...commonTracks,
        shopid: shopId || '-100',
      });
      const params = _.omitBy(
        {
          k: keyword,
          ...(shopId && { shopKeywords: keyword, shopId }),
          channelPageName,
          poolIdList,
          ...(shouldAddTopKeyFilters && { topKeyFilters: 'channel_page_filter' }),
          st: 'suggestion',
        },
        (v) => v === undefined || v === '',
      );
      router.push(`/s?${new URLSearchParams(params).toString()}`);
    }
  };

  useEffect(() => {
    if (defaultKeyword) {
      setKeyword(defaultKeyword);
    }
  }, [defaultKeyword]);

  useEffect(() => {
    // 搜索类型为历史搜索或者热搜词时，不发送搜索词
    if (searchType == 'search history' || searchType == 'hot search') return;
    if (keyword) {
      handleSuggestWordsRequest(keyword);
    }
  }, [keyword]);

  useEffect(() => {
    getHotWords(getShopIdWithDefault());
    getRecentlySearched();
    getShop(getShopIdWithDefault());
  }, []);

  return (
    <div
      className={cn(styles.searchBar, {
        [styles.active]:
          isFocusedSearchInput &&
          !(
            suggestWords.length === 0 &&
            recentlySearched.length === 0 &&
            hotWordsList.length === 0
          ),
      })}
      onClick={() => setIsFocusedSearchInput(true)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <input
        className={styles.searchInput}
        value={keyword}
        placeholder={
          shopInfoVO?.shopName
            ? (t('header.searchInShop', { shopName: shopInfoVO.shopName }) ??
              t('header.searchPlaceholder'))
            : defaultWords.length > 0
              ? defaultWords[currentIndex]
              : t('header.searchPlaceholder')
        }
        onChange={handleInputChange}
        onKeyDown={handleSearchKeyDown}
        type='text'
        onClick={handleSearchInputClick}
        exptag={'exp|' + EXPOSURE_RECORD25149.Search_SearchBox_Expo}
        data-exptag-config={EXPCONFIG_FAST}
        data-exptag-json-param={createTrackParams<
          IExpoTrackParamsRecord25149['Search_SearchBox_Expo']
        >({
          channelName,
          shopid: getShopIdWithDefault() || '-100',
        })}
      />
      <div className={styles.searchBtnWrap}>
        <button
          className={styles.searchBtn}
          onClick={handleSearchClick}
          exptag={'exp|' + EXPOSURE_RECORD25149.Search_SearchBtn_Expo}
          data-exptag-config={EXPCONFIG_FAST}
          data-exptag-json-param={createTrackParams<
            IExpoTrackParamsRecord25149['Search_SearchBtn_Expo']
          >({
            channelName,
            shopid: getShopIdWithDefault() || '-100',
          })}
          aria-label='search button'
        >
          <SearchBtn />
        </button>
      </div>
      <div
        className={cn(styles.searchRecommendedDropdownLayer, {
          [styles.suggestWords]: suggestWords.length > 0 && !shopInfoVO?.shopName,
        })}
      >
        {/* 联想词部分，店铺内搜索不展示联想词 */}
        {suggestWords.length > 0 && !shopInfoVO?.shopName ? (
          <div className={styles.searchView}>
            <ul>
              {suggestWords.map((item, sugWord_idx) => (
                <li
                  className={styles.suggestWordItem}
                  // 这里要用sugWord_idx作为key，因为不同keyword搜出来的联想词可能会重复，导致react渲染异常，顺序不是接口下发的顺序
                  key={item.keyword + sugWord_idx}
                  onClick={() => {
                    setSearchType('suggestion');
                    handleSelectKeywords(
                      item.keyword,
                      item.word,
                      sugWord_idx,
                      keyword,
                      item.type,
                      item.suggestShopVO?.shopId,
                    );
                    sendClickTrack24270.Search_SearchBtn({
                      keyWord: item.keyword,
                      shopid: getShopIdWithDefault() || '-100',
                      searchtype: 'suggestion',
                      ...commonTracks,
                    });
                  }}
                  // 判断 item.type === 1 是否为店铺入口  0平台  1店铺
                  exptag={
                    'exp|' +
                    (item.type === 1
                      ? EXPOSURE_RECORD.Search_Sug_Shop_Entry_Expo
                      : EXPOSURE_RECORD.Search_Sug_AssociativeWord_Expo)
                  }
                  data-exptag-config={item.type === 1 ? EXPCONFIG_DELAY : EXPCONFIG_FAST}
                  data-exptag-json-param={createTrackParams(
                    item.type === 1
                      ? {
                          index: sugWord_idx,
                          keyword: item.keyword,
                          ...commonTracks,
                          shopid: item.suggestShopVO?.shopId || '-100',
                        }
                      : {
                          pos: sugWord_idx,
                          keyWord: item.keyword,
                          Input_Keyword: keyword,
                          ...commonTracks,
                          shopid: item.suggestShopVO?.shopId || '-100',
                        },
                  )}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.highlightedKeyword }} />
                  {item.miniKeyword && <span>{item.miniKeyword}</span>}
                  {item.type === 1 && (
                    <div className={styles.goRight}>
                      <span className={styles.shopIcon}>
                        <CDNImage
                          src={item.suggestShopVO?.shopLogoUrl || ''}
                          width={24}
                          height={24}
                        />
                      </span>
                      <SearchRight />
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <>
            {/* 店铺内搜索 搜索历史 false */}
            {recentlySearched && recentlySearched.length > 0 && !getShopIdWithDefault() ? (
              <div className={styles.searchView}>
                <div className={styles.title}>{t('header.recentSearch')}</div>
                <button
                  className={styles.deleteHistoryBtn}
                  onClick={clearRecentKeywords}
                  exptag={'exp|' + EXPOSURE_RECORD25149.Search_Delete_Expo}
                  data-exptag-config={EXPCONFIG_FAST}
                  data-exptag-json-param={createTrackParams<
                    IExpoTrackParamsRecord25149['Search_Delete_Expo']
                  >({
                    channelName,
                    shopid: getShopIdWithDefault() || '-100',
                  })}
                >
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fill='currentColor'
                      fillRule='evenodd'
                      clipRule='evenodd'
                      d='M12 5H4V13H12V5ZM3 4V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V4H3Z'
                    />
                    <rect fill='currentColor' x='2' y='4' width='12' height='1' rx='0.5' />
                    <rect fill='currentColor' x='6' y='2' width='4' height='1' rx='0.5' />
                    <rect
                      fill='currentColor'
                      x='7'
                      y='7'
                      width='4'
                      height='1'
                      rx='0.5'
                      transform='rotate(90 7 7)'
                    />
                    <rect
                      fill='currentColor'
                      x='10'
                      y='7'
                      width='4'
                      height='1'
                      rx='0.5'
                      transform='rotate(90 10 7)'
                    />
                  </svg>
                </button>
                <ul className={styles.tags}>
                  {recentlySearched.map((item: any) => (
                    <li
                      className={styles.tag}
                      key={item}
                      exptag={'exp|' + EXPOSURE_RECORD25149.Search_History_Expo}
                      data-exptag-config={EXPCONFIG_FAST}
                      data-exptag-json-param={createTrackParams<
                        IExpoTrackParamsRecord25149['Search_History_Expo']
                      >({
                        keyWord: item,
                        ...commonTracks,
                        shopid: getShopIdWithDefault() || '-100',
                      })}
                    >
                      <div
                        onClick={() => {
                          setKeyword(item);
                          sendClickTrack25149.Search_History({
                            keyWord: item,
                            ...commonTracks,
                            shopid: getShopIdWithDefault() || '-100',
                          });
                          setSearchType('search history');
                          handleQuickSearch(item, 'search history');
                        }}
                      >
                        {item}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            {hotWordsList && hotWordsList.length > 0 ? (
              <div className={styles.searchView}>
                <div className={styles.title}>
                  {getShopIdWithDefault() ? t('header.trends') : t('header.hotSearch')}
                </div>
                <ul className={styles.tags}>
                  {hotWordsList.map((item: any, hotword_idx: number) => (
                    <li
                      className={styles.tag}
                      key={item.keyword}
                      exptag={'exp|' + EXPOSURE_RECORD24270.Search_Hotword_Expo}
                      data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
                      data-exptag-json-param={JSON.stringify({
                        pos: hotword_idx,
                        keyWord: item.keyword,
                        shopid: getShopIdWithDefault() || '-100',
                        request_id: item?.extMap?.requestId,
                        algo_rd_inf: item?.extMap?.algoid,
                        ...commonTracks,
                      })}
                    >
                      <div
                        onClick={() => {
                          setKeyword(item.keyword);
                          sendClickTrack25149.Search_Hotword({
                            keyWord: item.keyword,
                            pos: hotword_idx,
                            ...commonTracks,
                            shopid: getShopIdWithDefault() || '-100',
                          });
                          setSearchType('hot search');
                          handleQuickSearch(item.keyword, 'hot search', item.extMap);
                        }}
                      >
                        {item.keyword}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default JDISearch;
